import { HTMLAttributes } from 'react';
import clsx from 'clsx';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export function Skeleton({ className, ...rest }: SkeletonProps) {
  return <div className={clsx('animate-pulse rounded-lg bg-elevated', className)} {...rest} />;
}
